"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinnerSummaryToJSON = exports.WinnerSummaryFromJSONTyped = exports.WinnerSummaryFromJSON = void 0;
function WinnerSummaryFromJSON(json) {
    return WinnerSummaryFromJSONTyped(json, false);
}
exports.WinnerSummaryFromJSON = WinnerSummaryFromJSON;
function WinnerSummaryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'winnerName': json['winnerName'],
        'rewardDescription': json['rewardDescription'],
    };
}
exports.WinnerSummaryFromJSONTyped = WinnerSummaryFromJSONTyped;
function WinnerSummaryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'winnerName': value.winnerName,
        'rewardDescription': value.rewardDescription,
    };
}
exports.WinnerSummaryToJSON = WinnerSummaryToJSON;
